import news from './news';

export default class menu {
  constructor() {
    new news();
  }
}
